/**
 * Cart category scopes for mapped PDF templates.
 * Scope format: Cart.Category.<Slug>.<Field>
 * Keep in sync with backend template/cart-category-scopes.ts
 */

type CartCategoryField = "Name" | "Qty" | "Color";

type CartCategoryScopeDef = {
    slug: string;
    category: string;
    fields: CartCategoryField[];
};

const CART_CATEGORY_SCOPE_DEFS: CartCategoryScopeDef[] = [
    { slug: "FieldShingles", category: "Field Shingles", fields: ["Name", "Qty", "Color"] },
    { slug: "Starter", category: "Starter", fields: ["Name", "Qty"] },
    { slug: "DoubleStarter", category: "Double Starter", fields: ["Name", "Qty"] },
    { slug: "HipAndRidge", category: "Hip & Ridge", fields: ["Name", "Qty"] },
    { slug: "IceAndWaterShield", category: "Ice & Water Shield", fields: ["Name", "Qty"] },
    { slug: "FieldDryInSynthetic", category: "Field Dry In Synthetic", fields: ["Name", "Qty"] },
    { slug: "FieldDryIn15Felt", category: "Field Dry In 15 Felt", fields: ["Name", "Qty"] },
    { slug: "ValleyLiner", category: "Valley Liner", fields: ["Name", "Qty"] },
    { slug: "DripEdgeEave", category: "Drip Edge / Eave", fields: ["Name", "Qty"] },
    { slug: "DripEdgeRake", category: "Drip Edge / Rake", fields: ["Name", "Qty"] },
    { slug: "HeadWallMetal", category: "Head Wall Metal", fields: ["Name", "Qty"] },
    { slug: "StepFlashing", category: "Step Flashing", fields: ["Name", "Qty"] },
    { slug: "RollValley", category: "Roll Valley", fields: ["Name", "Qty"] },
    { slug: "CounterFlashing", category: "Counter Flashing", fields: ["Name", "Qty"] },
    { slug: "ValleyMetal", category: "Valley metal", fields: ["Name", "Qty"] },
    { slug: "BoxRoofVent", category: "Box Roof Vent", fields: ["Name", "Qty"] },
    { slug: "TurbineRoofVent", category: "Turbine Roof Vent", fields: ["Name", "Qty"] },
    { slug: "RidgeVent", category: "Ridge Vent", fields: ["Name", "Qty"] },
    { slug: "PlumbingJacks", category: "Plumbing Jacks", fields: ["Name", "Qty"] },
    { slug: "Splitboot", category: "Splitboot", fields: ["Name", "Qty"] },
    { slug: "FurnaceJacks", category: "Furnace Jacks", fields: ["Name", "Qty"] },
    { slug: "FurnaceCap", category: "Furnace Cap", fields: ["Name", "Qty"] },
    { slug: "FurnaceCollar", category: "Furnace Collar", fields: ["Name", "Qty"] },
    { slug: "BathVent", category: "Bath Vent", fields: ["Name", "Qty"] },
    { slug: "DryerVent", category: "Dryer Vent", fields: ["Name", "Qty"] },
    { slug: "RoofNails", category: "Roof Nails", fields: ["Name", "Qty"] },
    { slug: "HRNails", category: "H&R Nails", fields: ["Name", "Qty"] },
    { slug: "PlasticCapNails", category: "Nails - Plastic cap nails", fields: ["Name", "Qty"] },
    { slug: "SealantAdhesive", category: "Sealant / Adhesive", fields: ["Name", "Qty"] },
    { slug: "SprayPaint", category: "Spray Paint", fields: ["Name", "Qty"] },
    { slug: "Gutters", category: "Gutters", fields: ["Name", "Qty", "Color"] },
    { slug: "Downspouts", category: "Downspouts", fields: ["Name", "Qty", "Color"] },
    { slug: "GutterScreens", category: "Gutter Screens", fields: ["Name", "Qty"] },
];

function cartCategoryScopeValue(slug: string, field: CartCategoryField): string {
    return `Cart.Category.${slug}.${field}`;
}

function cartCategoryScopeLabel(category: string, field: CartCategoryField): string {
    const fieldLabel =
        field === "Name" ? "Product Name" : field === "Qty" ? "Quantity" : "Color";
    return `Cart · ${category} · ${fieldLabel}`;
}

export function buildCartCategoryScopeOptions(): Array<{ value: string; label: string }> {
    const options: Array<{ value: string; label: string }> = [];
    for (const def of CART_CATEGORY_SCOPE_DEFS) {
        for (const field of def.fields) {
            options.push({
                value: cartCategoryScopeValue(def.slug, field),
                label: cartCategoryScopeLabel(def.category, field),
            });
        }
    }
    return options;
}
